<template>
  <div class="tenantInfos">
    <div class="filters">
      <!-- 添加输入框和选择框、提交按钮 -->
      <el-form :inline="true">
        <!-- 姓名 -->
        <el-form-item>
          <el-input class="seachInput" v-model="name" clearable :placeholder="$t('lang.lab_Adminnickname')"></el-input>
        </el-form-item>
        <!-- 电话 -->
        <el-form-item>
          <el-input class="seachInput" v-model="mobile" clearable :placeholder="$t('lang.lab_telephoneNum')"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input class="seachInput" v-model="placeNum" clearable :placeholder="$t('lang.lab_parkingNumber')"></el-input>
        </el-form-item>
         <el-form-item>
          <el-input class="seachInput" v-model="roomDescribe" clearable :placeholder="$t('lang.lab_detailAdd')"></el-input>
        </el-form-item>
        <!-- 选择状态 -->
        <el-form-item>
          <el-select
            class="select"
            v-model="status"
						clearable
            :placeholder="$t('lang.TENANTINFOS.TYPE[0].label')">
            <el-option
              v-for="item in statuss"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-button type="primary" @click="submit()">{{$t('lang.btn_search')}}</el-button>
      </el-form>
      <!-- 添加表格 -->
    </div>
    <el-card>
      <el-table :data="tableData" class="wid100" :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109" :row-class-name="tableRowClassName" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="30" v-if="tenantInfosListcheckbox"></el-table-column>
        <el-table-column type="index" :index="indexMethod" align="center" :label="$t('lang.lab_index')" width="50px"></el-table-column>
        <!-- 申请时间 -->
        <!-- <el-table-column prop="applicationTime" sortable :label="$t('lang.lab_applicationTime')"></el-table-column> -->
        <!-- 业主姓名 -->
        <el-table-column prop="name" align="center" :label="$t('lang.lab_ownerName')" width="80px"></el-table-column>
        <!-- 业主电话 -->
        <el-table-column prop="mobile" align="center" :label="$t('lang.lab_ownerTel')"></el-table-column>
        <!--  -->
        <el-table-column prop="roomDescribe" align="center" :label="$t('lang.lab_detailAdd')"></el-table-column>
        <!-- 车位号 -->
        <el-table-column prop="parkingNum" align="center" :label="$t('lang.lab_carNumber')"></el-table-column>
        <!-- 身份证 -->
        <el-table-column :label="$t('lang.lab_idInfo')" prop="urlList" align="center" width="220px">
          <template slot-scope="scope">
            <viewer :images="scope.row.urlList" class="img-width">
              <template v-for="(src,index) in scope.row.urlList">
                <img
                v-if="src.type==1"
                :src="src.url"
                :key="index"
                class="img">
              </template>
            </viewer>
          </template>
        </el-table-column>
         <!-- 房产证 -->
        <el-table-column :label="$t('lang.lab_urlContract')" align="center" prop="urlList" width="100px">
          <template slot-scope="scope">
            <viewer :images="scope.row.urlList" class="img-width">
              <template v-for="(src,index) in scope.row.urlList">
                <img
                v-if="src.type==2"
                :src="src.url"
                :key="index"
                class="img">
              </template>
            </viewer>
          </template>
        </el-table-column>
        <!-- 行车证 -->
        <el-table-column :label="$t('lang.lab_drivingBook')" prop="urlList" align="center" width="100px">
          <template slot-scope="scope">
            <viewer :images="scope.row.urlList" class="img-width">
              <template v-for="(src,index) in scope.row.urlList">
                <img
                v-if="src.type==3"
                :src="src.url"
                :key="index"
                class="img">
              </template>
            </viewer>
          </template>
        </el-table-column>
        <!-- 结婚证 -->
        <el-table-column :label="$t('lang.lab_marriageCertificate')" prop="urlList" align="center" width="100px">
          <template slot-scope="scope">
            <viewer :images="scope.row.urlList" class="img-width">
              <template v-for="(src,index) in scope.row.urlList">
                <img
                v-if="src.type==4"
                :src="src.url"
                :key="index"
                class="img">
              </template>
            </viewer>
          </template>
        </el-table-column>
				<!-- 户口本 -->
				<el-table-column :label="$t('lang.lab_familyRegister')" prop="urlList" align="center" width="100px">
					<template slot-scope="scope">
						<viewer :images="scope.row.urlList" class="img-width">
							<template v-for="(src,index) in scope.row.urlList">
								<img
								v-if="src.type==5"
								:src="src.url"
								:key="index"
								class="img">
							</template>
						</viewer>
					</template>
				</el-table-column>
				<!-- 车位号 -->
				<el-table-column prop="placeNum" align="center" :label="$t('lang.lab_parkingNumber')"></el-table-column>
				<!-- 拒绝原因 -->
				<el-table-column prop="content" align="center" :label="$t('lang.lab_refusalCause')"></el-table-column>
        <!-- 商户订单号 -->
        <el-table-column prop="payOrder" align="center" :label="$t('lang.lab_payOrder')" width="100px"></el-table-column>
        <el-table-column prop="createTime" align="center" :label="$t('lang.lab_ctDoorDeviceSon')" width="100px">
          <template slot-scope="scope">{{scope.row.createTime | time}}</template>
        </el-table-column>
        <el-table-column prop="Prompt" align="center" :label="$t('lang.lab_prompt')">
          <template slot-scope="scope">
                <span v-if="scope.row.Prompt === 1" style="color: red;">{{$t('lang.lab_Prompt1')}}</span>
                <span v-else-if="scope.row.Prompt === 2" style="color:red">{{$t('lang.lab_Prompt2')}}</span>
                <span v-else-if="scope.row.Prompt === 3" style="color:red">{{$t('lang.lab_Prompt3')}}</span>
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column prop="operation" :label="$t('lang.lab_operation')" align="center" :width="require('@/config/enum').opr_width2">
          <template slot-scope="scope">
            <el-button @click="confirm(scope.row)" v-if="(scope.row.flag === '' || scope.row.flag === 0)">{{$t('lang.btn_cof')}}</el-button> 
            <el-button @click="refuse(scope.row)"  v-if="(scope.row.flag === '' || scope.row.flag === 0)">{{$t('lang.btn_refuse')}}</el-button>
            <span class="green" @click="alConfirm(scope.row)" v-else-if="(scope.row.flag === 1)">{{$t('lang.btn_alcof')}}</span>
            <span style="color: red;" @click="alRefuse(scope.row)" v-else-if="(scope.row.flag === 2)">{{$t('lang.btn_alRefuse')}}</span>
						<span class="blue" v-else-if="(scope.row.flag === 3)">{{$t('lang.lab_paidNotSel')}}</span>
						<span class="green" v-else-if="(scope.row.flag === 4)">{{$t('lang.lab_paidSel')}}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount"/>
    </el-card>
      <el-dialog :visible.sync="diaIsShow" :close-on-click-modal="false"
        :title="titleShow"
        center
        top="150px"
        width="500px"
        @closed="handleDialogClosed">
        <el-form :rules="rules" ref="form" :model="form" :label-width="require('@/config/enum').c_w1">
          <el-form-item prop="name" class="formname">
            <el-input v-model="form.name" :placeholder="$t('lang.lab_pleInputRefReason')"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="diaCancel()">{{$t('lang.btn_cancel')}}</el-button>
          <el-button type="primary" @click="diaConfirm('form')">{{$t('lang.btn_confirm')}}</el-button>
        </div>
      </el-dialog>
  </div>
</template>

<script>
/**
 *@ClassName:tenantInfos
 *@Description:租客审批
 *@author:李斌
 *@Copyright:格众科技
 *@date:2020-03-13
 */
import { mapGetters } from 'vuex'

export default {
  name:'/manage/main.parkingLotteryManager',
  data() {
    return {
      titleShow: '',
      Id: '',
      flag: '',
      content: '',
      diaIsShow: false, // 弹框是否显示
      tableData: [], // 表单数据
      multipleSelection: [], // 多选框
      name: '', // 租客姓名
      mobile: '', // 租客电话
      placeNum: '', // 车位号
      roomDescribe: '', // 详细地址
      status: '', // 状态
      statuss: this.$i18n.t('lang.TENANTINFOS.TYPE'), // 可选状态
      pageCount: 0, // 总页数
      pageNo: 1, // 页数
      pageSize: 10, // 每页显示数量
      tenantInfosListcheckbox: require('@/config/enum').tenantInfosListcheckbox, // 是否隐藏复选框  
      form: {
        name: '',
      },
      urlContract: [],
      rules: {
        name: [
          {
            required: true, message: this.$i18n.t('lang.lab_pleInputRefReason'), trigger: 'blur'
          }
        ],       
      }
    }
  },
  // 初始化
  created() {
    this.topics()
  },
  computed: {
    ...mapGetters(['gardenId'])
  },
  // 监听小区编号变化
  watch: {
    gardenId: function (newFlag, oldFlag) {
      this.topics()
    }
  },
  methods: {
    // ID序号功能
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
    // 列表斑马线
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 多选框
    handleSelectionChange(val) {
      this.multipleSelection = val
    }, 
    // 点击提交
    submit() {
      this.pageNo = 1
      this.topics()
    },  
    confirm(row) {
      this.Id = row.Id
      this.flag = 1
      let loading = this.$loading()
      this.$patch(
        `updateParkingLotteryFlag?id=${this.Id}&flag=${this.flag}`
      ).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
            this.topics()            
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    refuse(row) {
      this.titleShow = this.$i18n.t('lang.lab_refReason')
      this.diaIsShow = true
      this.Id = row.Id
      this.flag = 2
    },
    diaCancel() {
      this.form.name = ''
      this.$refs.form.clearValidate()
      this.diaIsShow = false
    },
    diaConfirm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let loading = this.$loading()
          let params = {
            id: this.Id,
            flag: this.flag,
            content: this.form.name
          }
          this.$patch(`/updateParkingLotteryFlag`, params).then(
            res => {
              loading.close()
              if (res && res.errCode === 0) {
                this.$message.success(this.$i18n.t('lang.lab_save_success'))
                this.diaIsShow = false
                this.topics()
              }
            },
            error => {
              loading.close()
              this.diaIsShow = false
              this.$message.error(error)
            }
          )         
        }
      })
    },
    topics() {
      let loading = this.$loading()
      this.$get(
        `getParkingLotteryList?Name=${this.name}&Mobile=${this.mobile}&PlaceNum=${this.placeNum}&RoomDescribe=${this.roomDescribe}&flag=${this.status}&gardenId=${this.gardenId}&pageNo=${this.pageNo}&pageSize=${this.pageSize}`
      ).then(
        res => {
					console.log(res.list)
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 监听关闭dialog
    handleDialogClosed() {
      this.diaCancel()
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNo = val
      this.topics()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.topics()
    }
  }
}
</script>

<style lang= 'scss'>
.tenantInfos{
  .img {
    width: 80px;
    height: 50px;
    border: 1px solid lightgray;
    border-radius: 5px;
    padding: 5px;
  }
  .img-width {
    overflow: hidden !important;
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    max-width: 320px;
  }
  .formname{
    text-align: center;
    width: 400px;
  }
  .green{
    color: #008000;
  }
} 
</style>